import React, { PureComponent } from 'react';
import { Trans } from 'translations';

export default class Skiplinks extends PureComponent {
    render() {
        return (
            <a className="skiplinks u-reset" href="#main">
                <Trans path="accessibility.goto_main" />
            </a>
        );
    }
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/skiplinks/index.js